module.exports = "//static.hsappstatic.net/conversations-internal-components/static-1.4266/audio/notification.mp3"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/conversations-visitor/node_modules/bender-webpack/lib/bender-url-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/audio/notification.mp3
// module id = 836
// module chunks = 2 3